export default "/images/file.svg?9f688bfa7c5eb6fd868dadc72ce807ee";